var SearchFaq = (function ($) {

    SearchFaq = function (options) {
        var that = this;

        // SELECTORS
        that.select_button_variant = '.js-button-variant'

        // DOM
        that.$wrapper = options["$wrapper"];

        that.$content_search_wrapper = that.$wrapper.find(
            ".js-faq-search-wrapper"
        );
        that.$content_search_input = that.$content_search_wrapper.find("input");
        that.$content_search_dropdown = that.$content_search_wrapper.find(".js-dd-button");

        // CONST
        that.passenger_categories = options["passenger_categories"];
        that.passenger_data_initial = options["passenger_data"];
        that.subsidized_routes = options["subsidized_routes"];

        // INIT
        that.init();
    };

    SearchFaq.prototype.init = function () {
        var that = this;

        that.initContentSearch();
        //
        that.initSearchVariantClick();
    };

    SearchFaq.prototype.initContentSearch = function () {
        var that = this;

        new ContentSearch({
            $wrapper: that.$content_search_wrapper,
            scrollbar_is_needed: true,
            controller_params: { content_type: "faq" },
        });
    };

    SearchFaq.prototype.initSearchVariantClick = function () {
        var that = this;

        $.sa.$document.on('click', that.select_button_variant, function (e) {
            var $variant_element = $(this)
            var variant_text = $variant_element.data('variant')

            that.$content_search_input.val(variant_text);
            that.$content_search_input.trigger("input");

            that.$content_search_dropdown.trigger("click");
        });
    };

    return SearchFaq;
})($);
